const parseCardName = (value: string) => {
  const parsedValue = value.replace(/[^a-z A-Z가-힣]/g, '');

  return parsedValue.toUpperCase();
};

export default parseCardName;
